"use client";

import { LineShadowText } from "@/components/ui/line-shadow-text";
import { useContent } from "@/components/site/ContentProvider";
import styles from "./work-line-shadow.module.css";

export function Work() {
  const site = useContent();
  const lastIndex = site.work.lines.length - 1;

  return (
    <div className="landing_content work_content f a-e" id="work">
      <div className="work_wrap f f-c">
        <div className="work_head f f-c _work_ele">
          {site.work.lines.map((line, i) => {
            if (i !== lastIndex) {
              return (
                <div className="work_head_line" key={line}>
                  <h2>{line}</h2>
                </div>
              );
            }
            const words = line.trim().split(/\s+/);
            const fast = words.pop() ?? "Fast.";
            const lead = words.join(" ");
            return (
              <div className="work_head_line" key={line}>
                <h2>
                  {lead ? <span className="dark_30">{lead} </span> : null}
                  <LineShadowText
                    as="span"
                    className={styles.fast}
                    shadowColor="black"
                  >
                    {fast.replace(/\.$/, "")}
                  </LineShadowText>
                  {fast.endsWith(".") ? (
                    <span className="dark_30">.</span>
                  ) : null}
                </h2>
              </div>
            );
          })}
        </div>
        <div className="work_bottom f">
          <span className="work_label small dark_60 _work_ele">
            {site.work.label.split("\n").map((part, i) => (
              <span key={part}>
                {i > 0 ? <br /> : null}
                {part}
              </span>
            ))}
          </span>
          <div className="work_grid f">
            {site.projects.map((project) => (
              <div className="work_thumb" key={project.id}></div>
            ))}
          </div>
        </div>
      </div>
      <div className="work_grid_h"></div>
    </div>
  );
}
